import { Controller, useFormContext } from 'react-hook-form';
import {
  AutocompleteRenderInputParams,
  Box,
  FormInputText,
  InputLabel,
  Select,
  Svg,
  SvgBubble,
  Tooltip,
} from '@hopskipdrive/react-components';

import { RiderFormValues } from '../../types';

const ROLE_OPTIONS = [
  { label: 'Caregiver', value: 'caregiver' },
  { label: 'Emergency Contact', value: 'emergency_contact' },
] as const;

const TOOLTIP_COPY =
  'Caregivers receive ride updates and can monitor rides in the HopSkipDrive app. ' +
  'Emergency contacts do not receive updates or monitor permissions. ' +
  'Each rider must have at least one caregiver.';

type RoleFieldProps = {
  index: number;
  disabled: boolean;
};

export const RoleField = ({ index, disabled }: RoleFieldProps) => {
  const { control, formState } = useFormContext<RiderFormValues>();
  const error = formState.errors.contacts?.[index]?.role?.message as string | undefined;

  return (
    <Box display="flex" flexDirection="column" gap="5px">
      <Box display="flex" alignItems="center" gap="12px">
        <InputLabel htmlFor={`contacts.${index}.role`}>Role</InputLabel>
        <Tooltip title={TOOLTIP_COPY} enterTouchDelay={0} leaveTouchDelay={3000}>
          <SvgBubble>
            <Svg icon="question" />
          </SvgBubble>
        </Tooltip>
      </Box>
      {disabled ? (
        <FormInputText
          id={`contacts.${index}.role`}
          variant="outlined"
          value="Caregiver"
          disabled
          fullWidth
          data-testid={`contacts.${index}.role`}
        />
      ) : (
        <Controller
          control={control}
          name={`contacts.${index}.role` as const}
          render={({ field: { value, onChange, onBlur } }) => (
            <Select
              id={`contacts.${index}.role`}
              options={[...ROLE_OPTIONS]}
              value={value}
              setValue={(v) => onChange(v)}
              renderInput={(params: AutocompleteRenderInputParams) => (
                <FormInputText
                  {...params}
                  inputProps={{ ...params.inputProps, id: `contacts.${index}.role` }}
                  variant="outlined"
                  fullWidth
                  error={!!error}
                  helperText={error}
                  data-testid={`contacts.${index}.role`}
                  onBlur={onBlur}
                />
              )}
            />
          )}
        />
      )}
    </Box>
  );
};
